import React from 'react';

interface Props {
    options: string[];
    defaultOption?: string;
    onChange: (name: string, value: string) => void;
    value?: string;
    name: string;
}

function NumberInput({
    value = '',
    options,
    onChange,
    defaultOption,
    name,
}: Props) {
    const [number, setNumber] = React.useState('');
    const [option, setOption] = React.useState('');

    React.useEffect(() => {
        const optionsPattern = options.join('|'); // Construct the pattern from the options array
        const regex = new RegExp(`^(\\d*\\.?\\d+)(${optionsPattern})`); // Construct the regular expression with the pattern
        const matches = value.match(regex); // Apply the regular expression to the value

        if (matches) {
            const extractedNumber = matches[1]; // Extract the number
            setNumber(extractedNumber);
            const extractedOption = matches[2]; // Extract the unit
            setOption(extractedOption);
        } else {
            setNumber('');
            setOption((currentOption) =>
                currentOption.length > 0
                    ? currentOption
                    : defaultOption ?? options[0],
            );
        }
    }, [defaultOption, options, value]);

    return (
        <div className="flex overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
            <input
                value={number}
                type="number"
                onChange={(e) => onChange(name, `${e.target.value}${option}`)}
                className="block min-w-0 flex-1 border-0 bg-transparent px-3 py-2 text-sm text-slate-700 focus:outline-none"
            />
            <select
                value={option}
                onChange={(e) => onChange(name, `${number}${e.target.value}`)}
                className="w-16 border-0 border-l border-slate-200 bg-slate-50 px-2 py-2 text-sm font-medium text-slate-600 focus:outline-none"
            >
                {options.map((el) => (
                    <option value={el} key={el}>
                        {el}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default NumberInput;
